import { useState, useEffect } from 'react';

// third-party imports
import PropTypes from 'prop-types';

// project-imports
import { isEmptyObject } from 'helpers/objectFunctions';

// material-ui
import Autocomplete from '@mui/material/Autocomplete';
import TextField from '@mui/material/TextField';
import { makeStyles } from '@mui/styles';

const useStyles = makeStyles(() => ({
    root: {
        '& .MuiOutlinedInput-root': {
            background: 'white',
            '& .MuiOutlinedInput-input': {
                background: 'white'
            }
        }
    }
}));

const AutoCompleteInput = ({
    id,
    label,
    options,
    values,
    isMultiSelect,
    freeSolo = false,
    getCustomLabel,
    customBg,
    textFieldStyle = {},
    renderInput = null,
    ...props
}) => {
    const classes = useStyles();
    const { disabled = false } = props || {};
    const handleGetOptionLabel = (option) => {
        if (getCustomLabel) {
            return getCustomLabel(option);
        }
        return option.name ?? option;
    };

    const [value, setValue] = useState(null);
    useEffect(() => {
        if (isEmptyObject(values) || !values) {
            setValue(null);
            return;
        }
        setValue([...Object.values(values)]);
    }, [values]);

    return (
        <Autocomplete
            className={!disabled && customBg ? classes.root : ''}
            id={id}
            freeSolo={freeSolo}
            value={value || []} // in case of multiselect=false, value will be picked from ...props as state value will be null
            multiple={isMultiSelect}
            getOptionLabel={(option) => handleGetOptionLabel(option)}
            options={options}
            {...props}
            sx={textFieldStyle}
            renderInput={
                renderInput || ((params) => <TextField {...params} label={label} error={props.error} helperText={props.helperText} />)
            }
        />
    );
};

AutoCompleteInput.propTypes = {
    id: PropTypes.string,
    label: PropTypes.string,
    options: PropTypes.array,
    values: PropTypes.object,
    isMultiSelect: PropTypes.bool,
    getCustomLabel: PropTypes.func
};

export default AutoCompleteInput;
